/* LM · 360° ring spins — Nivoda / Loupe360 turntables.
   Spins NEVER autoplay. A card spin only plays (and loops) after the shopper taps its 360° badge; tap again to stop.
   1. Keeps every spinning ring on the page in perfect sync (same angle at the same moment).
   2. LMSpin.scan(root): activates <video class="lm-card__spin" data-cands data-metal> cards.
   3. Adds spins to standard product cards (collection / search grids) automatically. */
(function () {
  if (window.LMSpin) return;
  var ROOT = 'https://s3.eu-west-2.amazonaws.com/loupe360.jewelry/';
  var tracked = new Set();

  /* ---------- sync clock ---------- */
  function target(v) { return (Date.now() / 1000) % v.duration; }
  function align(v, force) {
    if (!v.duration || !isFinite(v.duration) || v.paused) return;
    var t = target(v), d = Math.abs(v.currentTime - t);
    d = Math.min(d, v.duration - d);
    if (force || d > 0.2) { try { v.currentTime = t; } catch (e) {} }
  }
  document.addEventListener('playing', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO' || !/loupe360\.jewelry/.test(v.currentSrc || v.src)) return;
    tracked.add(v); align(v);
  }, true);
  setInterval(function () {
    tracked.forEach(function (v) { if (!v.isConnected) { tracked.delete(v); return; } align(v); });
  }, 1000);

  /* ---------- block autoplay on every card spin (incl. other loaders) ---------- */
  function cardOf(v) { return v.closest('.lm-card, .card-wrapper') || v.parentNode; }
  function off(v) {
    var c = cardOf(v); v.classList.remove('is-on');
    if (c) { c.classList.remove('is-spinning'); var b = c.querySelector('.lm-card__360'); if (b) b.classList.remove('is-playing'); }
  }
  document.addEventListener('play', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO' || !v.classList.contains('lm-card__spin')) return;
    if (!v.dataset.lmUser) { v.pause(); off(v); }
  }, true);

  /* ---------- card spins ---------- */
  function cand(v) { return v.dataset.cands.split(',')[+v.dataset.ci || 0] + v.dataset.metal + '.mp4'; }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (!x.isIntersecting && !x.target.paused) { x.target.pause(); delete x.target.dataset.lmUser; off(x.target); } });
  }, { threshold: 0 }) : null;

  function initVideo(v) {
    if (v.dataset.lmInit) return; v.dataset.lmInit = '1';
    v.loop = true; v.removeAttribute('autoplay'); v.autoplay = false;
    var card = cardOf(v);
    v.addEventListener('playing', function () {
      if (!v.dataset.lmUser) { v.pause(); return; }
      v.classList.add('is-on'); card.classList.add('is-spinning');
      var b = card.querySelector('.lm-card__360'); if (b) b.classList.add('is-playing');
    });
    v.addEventListener('error', function () {
      if (!v.dataset.cands) return;
      var n = (+v.dataset.ci || 0) + 1;
      if (n < v.dataset.cands.split(',').length) { v.dataset.ci = n; v.src = cand(v); if (v.dataset.lmUser) play(v); return; }
      card.classList.remove('lm-card--spin', 'is-spinning');
      var b = card.querySelector('.lm-card__360'); if (b) b.remove(); v.remove();
    });
    if (io) io.observe(v);
  }
  function scan(root) {
    (root || document).querySelectorAll('video.lm-card__spin').forEach(initVideo);
  }

  /* tap the 360° badge to play / stop (does not open the product) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lm-card__360'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var card = b.closest('.lm-card, .card-wrapper') || b.parentNode;
    var v = card && card.querySelector('video.lm-card__spin'); if (!v) return;
    initVideo(v);
    if (v.dataset.lmUser && !v.paused) { delete v.dataset.lmUser; v.pause(); off(v); return; }
    v.dataset.lmUser = '1';
    if (!v.getAttribute('src') && v.dataset.cands) { v.dataset.ci = 0; v.src = cand(v); }
    play(v);
  }, true);

  /* ---------- standard product cards ---------- */
  var SH = { oval: 'OV', pear: 'PE', emerald: 'EM', radiant: 'RAD', cushion: 'CU', marquise: 'MQ', princess: 'PR' };
  function candsFor(fn, handle) {
    var m = fn.match(/^(.+?)_(WHITE|YELLOW|ROSE)_DOWN/); if (!m) return null;
    var base = m[1], list = [];
    if (base.indexOf('-') > -1) list.push(ROOT + base + '/' + base + '_Renders/' + base + '_');
    else {
      var sh = 'RD'; for (var k in SH) if (handle.indexOf(k) > -1) { sh = SH[k]; break; }
      [sh, 'RD'].filter(function (s, i, a) { return a.indexOf(s) === i; }).forEach(function (s) {
        var f = base + '-' + s, dir = ROOT + f + '/' + f + '_Renders/';
        list.push(dir + base + '_', dir + f + '_');
      });
    }
    return { cands: list.join(','), metal: m[2] };
  }
  function enhanceCards(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (cw) {
      if (cw.dataset.lmSpin) return; cw.dataset.lmSpin = '1';
      var media = cw.querySelector('.card__media .media'), img = media && media.querySelector('img');
      var a = cw.querySelector('a[href*="/products/"]'); if (!img || !a) return;
      var fn = (img.getAttribute('src') || '').split('?')[0].split('/').pop();
      var handle = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
      var c = candsFor(fn, handle); if (!c) return;
      var v = document.createElement('video');
      v.className = 'lm-card__spin'; v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'none'); v.setAttribute('aria-hidden', 'true');
      v.dataset.cands = c.cands; v.dataset.metal = c.metal;
      var badge = document.createElement('span'); badge.className = 'lm-card__360'; badge.textContent = '360°';
      media.appendChild(v); media.appendChild(badge); cw.classList.add('lm-card--spin');
      initVideo(v);
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.card-wrapper .card__media .media .lm-card__spin{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;opacity:0;transition:opacity .7s ease;z-index:2;pointer-events:none;background:transparent}' +
    '.card-wrapper .card__media .media .lm-card__spin.is-on{opacity:1}' +
    '.card-wrapper.is-spinning .card__media .media img{opacity:0!important;transition:opacity .7s ease}' +
    '.card-wrapper .lm-card__360{position:absolute;left:10px;top:10px;z-index:3;font-size:9px;letter-spacing:.2em;color:#7C4823;border:1px solid rgba(17,16,9,.12);border-radius:999px;padding:3px 8px;background:rgba(255,255,255,.75);font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}' +
    '.lm-card__360{cursor:pointer;pointer-events:auto!important;z-index:4!important;-webkit-tap-highlight-color:transparent;padding:6px 10px!important}' +
    '.lm-card__360::before{content:"\\25B6\\00a0";font-size:8px;letter-spacing:0}' +
    '.lm-card__360.is-playing::before{content:"\\275A\\275A\\00a0";font-size:7px}';
  document.head.appendChild(css);

  function boot() { scan(document); enhanceCards(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* re-run after filtering / sorting / infinite scroll re-renders the grid */
  if ('MutationObserver' in window) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(boot, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  window.LMSpin = { scan: scan, enhanceCards: enhanceCards, align: align };
})();
